import { render, staticRenderFns } from "./bookFormItem.vue?vue&type=template&id=42c2abc0&"
import script from "./bookFormItem.vue?vue&type=script&lang=js&"
export * from "./bookFormItem.vue?vue&type=script&lang=js&"
import style0 from "./bookFormItem.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports